import classNames from 'classnames';
import React from 'react';

import { ReactComponent as PlayIcon } from '../../assets/play.svg';
import { ReactComponent as SpinnerIcon } from '../../assets/spinner.svg';
import {
	container,
	hidden,
	icon as iconStyle,
	shown,
	title as titleStyle,
	video as videoStyle,
	videoOnlyContainer,
} from './style.module.css';
import { PlaybackState, useVideoPlayer } from './use-video-player';

export interface VideoPlayerProps {
	// @todo: pass in url, title and description directly
	video: Partial<Queries.ContentfulAsset>;
	videoOnly?: boolean;
}

export const VideoPlayer = ({ video, videoOnly = false }: VideoPlayerProps): JSX.Element => {
	const { videoRef, toggleVideoPlayback, state } = useVideoPlayer();
	const { title, description, url } = video;

	if (!url) {
		console.warn('Missing Video URL, returning empty fragment');
		return <></>;
	}

	const handleOnClickVideoPlayer = () => toggleVideoPlayback();

	return (
		<section
			onClick={handleOnClickVideoPlayer}
			className={classNames(
				videoOnly
					? videoOnlyContainer
					: [container, state === PlaybackState.Playing ? hidden : shown]
			)}
		>
			<div className={videoStyle}>
				{state !== PlaybackState.Playing && (
					<div className={iconStyle}>
						{(state === PlaybackState.Paused || state === PlaybackState.Stopped) && (
							<PlayIcon data-play />
						)}
						{state === PlaybackState.Loading && <SpinnerIcon data-spinner />}
					</div>
				)}
				<video
					ref={videoRef}
					src={url}
					data-playing={state === PlaybackState.Playing ? 'playing' : undefined}
				/>
			</div>
			{!videoOnly && (
				<div className={titleStyle}>
					{!!title && <h1>{title}</h1>}
					{!!description && <p>{description}</p>}
				</div>
			)}
		</section>
	);
};
